import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24d0677e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "advanced-row" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = {
  key: 0,
  class: "text"
}
const _hoisted_5 = {
  key: 1,
  class: "text"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-value" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_9 = { class: "advanced-row" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = {
  key: 0,
  class: "text"
}
const _hoisted_12 = {
  key: 1,
  class: "text"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-value" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_16 = { class: "advanced-row" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = {
  key: 0,
  class: "text"
}
const _hoisted_19 = {
  key: 1,
  class: "text"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-value" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_23 = { class: "advanced-row" }
const _hoisted_24 = { class: "label" }
const _hoisted_25 = {
  key: 0,
  class: "text"
}
const _hoisted_26 = {
  key: 1,
  class: "text"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-value" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_30 = { class: "advanced-row" }
const _hoisted_31 = { class: "label" }
const _hoisted_32 = {
  key: 0,
  class: "text"
}
const _hoisted_33 = {
  key: 1,
  class: "text"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-value" }, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_37 = { class: "advanced-row" }
const _hoisted_38 = { class: "label" }
const _hoisted_39 = {
  key: 0,
  class: "text"
}
const _hoisted_40 = {
  key: 1,
  class: "text"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-value" }, null, -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_44 = { class: "advanced-row" }
const _hoisted_45 = { class: "label" }
const _hoisted_46 = {
  key: 0,
  class: "text"
}
const _hoisted_47 = {
  key: 1,
  class: "text"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-value" }, null, -1))
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = {
  key: 2,
  class: "text"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_52 = { class: "advanced-row" }
const _hoisted_53 = { class: "label" }
const _hoisted_54 = {
  key: 0,
  class: "text"
}
const _hoisted_55 = {
  key: 1,
  class: "text"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-value" }, null, -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_59 = { class: "advanced-row" }
const _hoisted_60 = { class: "label" }
const _hoisted_61 = {
  key: 0,
  class: "text"
}
const _hoisted_62 = {
  key: 1,
  class: "text"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-value" }, null, -1))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_66 = { class: "advanced-row" }
const _hoisted_67 = { class: "label" }
const _hoisted_68 = {
  key: 0,
  class: "text"
}
const _hoisted_69 = {
  key: 1,
  class: "text"
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-value" }, null, -1))
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "thin-divider" }, null, -1))
const _hoisted_73 = { class: "advanced-row" }
const _hoisted_74 = { class: "label" }
const _hoisted_75 = { class: "text" }
const _hoisted_76 = {
  key: 0,
  class: "thin-divider"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("contractSummary.partnerName")), 1),
      (_ctx.contractPartnerName)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.contractPartnerName), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("contractSummary.contractSummary")), 1),
      (_ctx.contractInformation?.contractOverview)
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.contractInformation.contractOverview), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
    ]),
    _hoisted_15,
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("contractSummary.contractExpiredTime")), 1),
      (_ctx.contractInformation?.contractConclusionDate)
        ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.formatLocalDate(
            _ctx.contractInformation.contractConclusionDate,
            _ctx.$t("contractSummary.dateFormat")
          )), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
    ]),
    _hoisted_22,
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("contractSummary.contractStart")), 1),
      (_ctx.contractInformation?.contractStartDate)
        ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(_ctx.formatLocalDate(
            _ctx.contractInformation.contractStartDate,
            _ctx.$t("contractSummary.dateFormat")
          )), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
    ]),
    _hoisted_29,
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("contractSummary.contractEnd")), 1),
      (_ctx.contractInformation?.contractEndDate)
        ? (_openBlock(), _createElementBlock("p", _hoisted_32, _toDisplayString(_ctx.formatLocalDate(
            _ctx.contractInformation.contractEndDate,
            _ctx.$t("contractSummary.dateFormat")
          )), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
    ]),
    _hoisted_36,
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t("contractSummary.cancelExpiredTime")), 1),
      (_ctx.contractInformation?.terminationNoticePeriod)
        ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.contractInformation.terminationNoticePeriod), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
    ]),
    _hoisted_43,
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("p", _hoisted_45, _toDisplayString(_ctx.$t("contractSummary.autoUpdate")), 1),
      (_ctx.contractInformation?.isAutomaticallyUpdated == 'true')
        ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.$t("template.updateOption1")), 1))
        : (_ctx.contractInformation?.isAutomaticallyUpdated == 'null')
          ? (_openBlock(), _createElementBlock("div", _hoisted_47, _hoisted_49))
          : (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(_ctx.$t("template.updateOption2")), 1))
    ]),
    _hoisted_51,
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.$t("contractSummary.controlNumber")), 1),
      (_ctx.contractInformation?.controlNumber)
        ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(_ctx.contractInformation.controlNumber), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_55, _hoisted_57))
    ]),
    _hoisted_58,
    _createElementVNode("div", _hoisted_59, [
      _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.$t("contractSummary.transactionAmount")), 1),
      (_ctx.isNumber(_ctx.contractInformation?.transactionAmount))
        ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(_ctx.formatThounsandNumber(Number(_ctx.contractInformation?.transactionAmount))), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
    ]),
    _hoisted_65,
    _createElementVNode("div", _hoisted_66, [
      _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.$t("contractSummary.freeText")), 1),
      (_ctx.contractInformation?.freeText)
        ? (_openBlock(), _createElementBlock("p", _hoisted_68, _toDisplayString(_ctx.contractInformation.freeText), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_69, _hoisted_71))
    ]),
    _hoisted_72,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractCustomFields, (field, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        _createElementVNode("div", _hoisted_73, [
          _createElementVNode("p", _hoisted_74, _toDisplayString(field.title), 1),
          _createElementVNode("p", _hoisted_75, _toDisplayString(field.value), 1)
        ]),
        (index != _ctx.contractCustomFields.length - 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_76))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}